import { t } from "@lingui/core/macro";
import {
  useDisclosure,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@heroui/react";
import CustomerList from "./CustomerList";
import { LimePageHeader } from "@/Components/LimePageHeader";
import { ManageCustomerModal } from "@/Components/NextBase/ManageCustomerModal";
import CustomerCard from "./OldCustomerCard/CustomerCard";
import { useState } from "react";
import { LimeModal } from "@/Components/NextBase/LimeModal";

const Customers = () => {
  const {
    isOpen: isAddDrawerOpen,
    onOpen: onAddDrawerOpen,
    onClose: onAddDrawerClose,
  } = useDisclosure();

  const {
    isOpen: isCustomerCardOpen,
    onOpen: onCustomerCardOpen,
    onClose: onCustomerCardClose,
  } = useDisclosure();

  const [selectedCustomerId, setSelectedCustomerId] = useState<number | null>(
    null,
  );

  return (
    <>
      <ManageCustomerModal
        isOpen={isAddDrawerOpen}
        handleClose={onAddDrawerClose}
        defaultEntityType="physical"
      />

      <LimePageHeader
        title={t`Stranke`}
        rightSection={{
          label: t`Dodaj stranko`,
          onClick: onAddDrawerOpen,
        }}
      />

      <div className="px-2 md:px-8">
        <CustomerList
          onClickCustomer={(customerId) => {
            setSelectedCustomerId(customerId);
            onCustomerCardOpen();
          }}
        />
      </div>
      <LimeModal
        isOpen={isCustomerCardOpen}
        onClose={onCustomerCardClose}
        size="full"
        scrollBehavior="inside"
      >
        <ModalContent>
          <ModalHeader>{t`Kartica stranke`}</ModalHeader>
          <ModalBody className="px-0 md:px-2">
            <CustomerCard
              customerId={selectedCustomerId}
              handleClose={onCustomerCardClose}
            />
          </ModalBody>
          <ModalFooter />
        </ModalContent>
      </LimeModal>
    </>
  );
};

export default Customers;
